// @mui
import { alpha, styled } from '@mui/material/styles';
import SimpleBar from 'simplebar-react';

// ----------------------------------------------------------------------

export const StyledRootScrollbar = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
}));

export const StyledScrollbar = styled(SimpleBar)(({ theme }) => ({
  '& .simplebar-mask': {
    zIndex: 'inherit',
  },
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
    },
    '&.simplebar-visible:before': {
      opacity: 1,
    },
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 6,
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 10,
  },
  maxHeight: '100%',
}));
